import { render, staticRenderFns } from "./apartmentInfoCard.vue?vue&type=template&id=1b1f1906&"
import script from "./apartmentInfoCard.vue?vue&type=script&lang=js&"
export * from "./apartmentInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports